import { DEFAULT_ROUTE } from '$constants'

import { updateCurrent } from '$store/session'
import { TokenDetail } from '$store/session/tokens'

import useReturnTo from './useReturnTo'
import useLoginAttentions from './useLoginAttentions'

/**
 * Used on `Login` pages.
 *
 * After successful logged in,
 * - mark the new session as active profile.
 * - Redirects to `?return_to=...` or fallback to `DEFAULT_ROUTE` route.
 */
export const useSuccessLogin = () => {
  const { resolveNow, setResolvedAction } = useLoginAttentions()
  const redirect = useReturnTo()

  const action = (user_id: TokenDetail['user_id']) => {
    updateCurrent(user_id)

    setResolvedAction(() => redirect(DEFAULT_ROUTE))
    resolveNow()
  }

  return action
}
